import React, { Suspense } from 'react';

import { SeriesStructureSkeleton } from './_SeriesStructureSkeleton';

const SeriesStructureLazy = React.lazy(() =>
    import('./SeriesStructureComponent').then((module) => ({
        default: module.SeriesStructureComponent,
    }))
);

export const SeriesStructure: React.FC<React.ComponentProps<typeof SeriesStructureLazy>> = (
    props
) => (
    <Suspense fallback={<SeriesStructureSkeleton />}>
        <SeriesStructureLazy {...props} />
    </Suspense>
);
